module.exports = "/_next/static/images/CharlesBurkeCowley-5efa71caabc55f7084ac2ba4ed75e781.webp";